import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Container, Col, Row, Button} from "reactstrap";
import "../vodafone.css"
import iconVodafoneLogoWhite from "../media/icons/vf-logo-white.png"


class BottomBarMeinVodafone extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        let content;
        content=<Row>
            <Col xs={8}>
                <Row style={{height:"28px"}}>
                    <Col xs={3}>
                        <img src={iconVodafoneLogoWhite} style={{height:"28px",width:"28px"}} />
                    </Col>
                    <Col xs={9} style={{paddingLeft:"6px"}}>
                        <p className={"text-bottom-bar-title-vodafone"}>{i18n.t(this.props.mainText, this.props)}</p>
                    </Col>
                </Row>
                <Row style={{marginTop:"16px"}}>
                    <Col xs={12}>
                        <p className={"text-bottom-bar-subtitle-vodafone"}>{i18n.t(this.props.subText, this.props)}</p>
                    </Col>
                </Row>
            </Col>
            <Col xs={4}>
                <Button
                    className={"button-white width-100"}
                    style={{height:"48px", marginTop:"64px"}}
                    onClick={this.props.buttonOnClick}>
                    {i18n.t(this.props.buttonTextResource, this.props)}
                </Button>
            </Col>
        </Row>;



        return <Container className={"round-corners shadow bottom-bar-mein-vodafone bg-red-gradient"} style={{marginTop:"16px"}}>
            {content}
        </Container>
    }
}

export default translate("translations")(BottomBarMeinVodafone);